﻿(() => {
  /** Aus Theme settings_data.json (shop_images → /cdn/shop/files/…) */
  const BAB_LOGO_CDN =
    'https://www.bab.de/cdn/shop/files/BAB_180-_LOGO_TRANSPERENT_07fa0364-5bfd-4152-a653-f6dc3089eb4f.png';

  const CONFIG = {
    apiUrl: (typeof window.BAB_ASSISTANT_URL === 'string' && window.BAB_ASSISTANT_URL) || 'http://localhost:3001',
    sessionKey: 'bab_ai_chat_v3',
    consentKey: 'bab_consent',
    /** Shop-Cookie-Banner (bab-cookie-banner.liquid) nutzt bab_cookie_consent */
    cookieConsentKey: 'bab_cookie_consent',
    greetKey: 'bab_ai_greet_v3',
    maxMessages: 10,
    maxChars: 500,
    colors: {
      red: '#9E3548',
      teal: '#6F9CA3',
      panel: '#1a1a1a',
      text: '#eceff4',
      muted: '#8b95a5'
    }
  };

  const suggestions = [
    { icon: '👨‍⚕️', text: 'Ich bin Arzt oder Ärztin' },
    { icon: '👩‍⚕️', text: 'Ich arbeite in der Pflege' },
    { icon: '👨‍🍳', text: 'Ich bin Koch oder Köchin' },
    { icon: '🔧', text: 'Ich bin Handwerker' },
    { icon: '🏨', text: 'Ich arbeite im Hotel oder Service' },
    { icon: '🦺', text: 'Ich brauche Sicherheitskleidung' }
  ];

  const state = {
    open: false,
    loading: false,
    history: loadHistory(),
    unreadCount: 0,
    sessionTracked: false
  };

  // ── DOM ──────────────────────────────────────────────────────────
  const root = document.createElement('div');
  root.id = 'bab-ai-widget-root';
  root.innerHTML = buildMarkup();
  document.body.appendChild(root);

  const fab       = root.querySelector('.bab-fab');
  const fabTip    = root.querySelector('.bab-fab-tooltip');
  const badge     = root.querySelector('.bab-badge');
  const panel     = root.querySelector('.bab-panel');
  const closeBtn  = root.querySelector('.bab-close');
  const minBtn    = root.querySelector('.bab-minimize');
  const greet     = root.querySelector('.bab-greeting');
  const chipRow   = root.querySelector('.bab-chips');
  const list      = root.querySelector('.bab-messages');
  const form      = root.querySelector('.bab-form');
  const input     = root.querySelector('.bab-input');
  const typing    = root.querySelector('.bab-typing');
  const charCount = root.querySelector('.bab-charcount');
  const consentBanner   = root.querySelector('.bab-consent-banner');
  const btnConsentFull  = root.querySelector('.bab-consent-full');
  const btnConsentMin   = root.querySelector('.bab-consent-minimal');
  const resizeHandle    = root.querySelector('.bab-resize-handle');

  // ── Events ───────────────────────────────────────────────────────
  fab.addEventListener('click', () => openPanel());
  closeBtn.addEventListener('click', () => closePanel());
  minBtn.addEventListener('click', () => minimizePanel());

  fab.addEventListener('mouseenter', () => fabTip.classList.add('visible'));
  fab.addEventListener('mouseleave', () => fabTip.classList.remove('visible'));

  chipRow.addEventListener('click', (e) => {
    const toggle = e.target.closest('.bab-chips-toggle');
    if (toggle) {
      const extra = chipRow.querySelector('.bab-chips-extra');
      if (extra) {
        const open = extra.classList.toggle('open');
        toggle.textContent = open ? 'Weniger anzeigen' : 'Mehr anzeigen';
      }
      return;
    }
    const b = e.target.closest('button[data-chip]');
    if (!b || state.loading) return;
    const text = b.getAttribute('data-chip');
    track('category_click', { category: text });
    pushUser(text);
    sendChat(text);
  });

  // Textarea auto-resize + char counter
  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
    const len = input.value.length;
    charCount.textContent = `${len}/${CONFIG.maxChars}`;
    charCount.style.color = len > 450 ? '#e55' : CONFIG.colors.muted;
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!state.loading) submitChat();
    }
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!state.loading) submitChat();
  });

  function submitChat() {
    const text = input.value.trim();
    if (!text) return;
    input.value = '';
    input.style.height = 'auto';
    charCount.textContent = `0/${CONFIG.maxChars}`;
    track('message', { message: text });
    pushUser(text);
    sendChat(text);
  }

  // Consent buttons
  btnConsentFull.addEventListener('click', () => setConsent('full'));
  btnConsentMin.addEventListener('click',  () => setConsent('minimal'));

  // Track product-link clicks
  list.addEventListener('click', (e) => {
    const link = e.target.closest('.bab-chat-link');
    if (link && link.href && link.href.includes('/products/')) {
      const handle = link.href.split('/products/')[1].split('?')[0].replace(/[/\s]+$/, '');
      track('product_click', { productHandle: handle, productTitle: link.textContent.trim() });
    }
  });

  // Custom resize handle (top-left corner → drag expands panel up+left)
  let resizing = false, rsX = 0, rsY = 0, rsW = 0, rsH = 0;
  resizeHandle.addEventListener('mousedown', (e) => {
    resizing = true;
    rsX = e.clientX; rsY = e.clientY;
    rsW = panel.offsetWidth; rsH = panel.offsetHeight;
    document.body.style.userSelect = 'none';
    e.preventDefault();
  });
  document.addEventListener('mousemove', (e) => {
    if (!resizing) return;
    const dw = rsX - e.clientX; // drag left = wider
    const dh = rsY - e.clientY; // drag up   = taller
    const newW = Math.min(700, Math.max(320, rsW + dw));
    const newH = Math.min(window.innerHeight * 0.9, Math.max(400, rsH + dh));
    panel.style.width  = newW + 'px';
    panel.style.height = newH + 'px';
  });
  document.addEventListener('mouseup', () => {
    if (resizing) { resizing = false; document.body.style.userSelect = ''; }
  });

  // ── Panel State ──────────────────────────────────────────────────
  function openPanel() {
    state.open = true;
    state.unreadCount = 0;
    updateBadge();
    panel.classList.add('open');

    if (!sessionStorage.getItem(CONFIG.greetKey)) {
      greet.style.display = 'flex';
      chipRow.style.display = 'flex';
      sessionStorage.setItem(CONFIG.greetKey, '1');
    } else {
      greet.style.display = 'none';
      chipRow.style.display = 'none';
    }

    const consent = getConsentLevel();
    consentBanner.style.display = consent !== 'none' ? 'none' : 'flex';

    renderMessages();
    requestAnimationFrame(() => input.focus());

    if (!state.sessionTracked) {
      state.sessionTracked = true;
      track('session_start');
    }
  }

  function closePanel() {
    state.open = false;
    state.unreadCount = 0;
    updateBadge();
    panel.classList.remove('open');
  }

  function minimizePanel() {
    state.open = false;
    panel.classList.remove('open');
    // badge will appear if sendChat finishes while panel is closed
  }

  function updateBadge() {
    if (state.unreadCount > 0) {
      badge.textContent = state.unreadCount > 9 ? '9+' : String(state.unreadCount);
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  // ── Consent ──────────────────────────────────────────────────────
  function getConsentLevel() {
    try {
      return (
        localStorage.getItem(CONFIG.cookieConsentKey) ||
        localStorage.getItem(CONFIG.consentKey) ||
        'none'
      );
    } catch {
      return 'none';
    }
  }

  function setConsent(level) {
    try {
      localStorage.setItem(CONFIG.consentKey, level);
      localStorage.setItem(CONFIG.cookieConsentKey, level);
    } catch (_) {}
    consentBanner.style.display = 'none';
    if (level !== 'none' && !state.sessionTracked) {
      state.sessionTracked = true;
      track('session_start');
    }
  }

  // ── Tracking ─────────────────────────────────────────────────────
  function track(event, data = {}) {
    const consent = getConsentLevel();
    if (consent === 'none') return;
    try {
      fetch(`${CONFIG.apiUrl}/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event, data, consent })
      }).catch(() => {});
    } catch (_) {}
  }

  // ── Chat Logic ───────────────────────────────────────────────────
  const WAITING_MESSAGES = [
    'Ich durchsuche unser Sortiment für Sie... 🔍',
    'Wir haben über 3.900 Produkte — ich suche das Beste für Sie... 📦',
    'Ich prüfe verfügbare Farben und Größen... 🎨',
    'Fast gefunden — ich gleiche noch die Details ab... ✓',
    'Ich schaue auch nach aktuellen Angeboten für Sie... 🏷️',
    'Einen Moment — ich finde die perfekte Option... 👗'
  ];

  let waitingIndex = 0;
  let waitingKickoffTimer = null;
  let waitingRotateTimer = null;

  function stopWaitingMessages() {
    if (waitingKickoffTimer != null) {
      clearTimeout(waitingKickoffTimer);
      waitingKickoffTimer = null;
    }
    if (waitingRotateTimer != null) {
      clearInterval(waitingRotateTimer);
      waitingRotateTimer = null;
    }
    waitingIndex = 0;
  }

  function updateTypingText(inlineEl, text) {
    if (!inlineEl) return;
    inlineEl.classList.remove('bab-typingfade');
    void inlineEl.offsetWidth;
    inlineEl.textContent = text;
    inlineEl.classList.add('bab-typingfade');
  }

  function startWaitingMessages() {
    stopWaitingMessages();
    waitingKickoffTimer = setTimeout(() => {
      waitingKickoffTimer = null;
      if (!state.loading) return;
      const inline = list.querySelector('.bab-msg-pending .bab-typing-inline');
      if (!inline) return;
      updateTypingText(inline, WAITING_MESSAGES[0]);
      waitingIndex = 1;
      if (WAITING_MESSAGES.length <= 1) return;
      waitingRotateTimer = setInterval(() => {
        if (!state.loading) {
          stopWaitingMessages();
          return;
        }
        const inline2 = list.querySelector('.bab-msg-pending .bab-typing-inline');
        if (!inline2) {
          stopWaitingMessages();
          return;
        }
        if (waitingIndex < WAITING_MESSAGES.length) {
          updateTypingText(inline2, WAITING_MESSAGES[waitingIndex]);
          waitingIndex += 1;
        } else {
          clearInterval(waitingRotateTimer);
          waitingRotateTimer = null;
        }
      }, 2000);
    }, 2000);
  }

  function pushUser(text) {
    state.history.push({ role: 'user', content: text, complete: true, ts: now() });
    trimHistory();
    renderMessages();
    persistHistory();
  }

  function trimHistory() {
    if (state.history.length > CONFIG.maxMessages) {
      state.history = state.history.slice(-CONFIG.maxMessages);
    }
  }

  async function sendChat(message) {
    stopWaitingMessages();
    state.loading = true;
    typing.classList.remove('visible');
    const assistantIdx = state.history.length;
    state.history.push({ role: 'assistant', content: '', complete: false, ts: now() });
    trimHistory();
    renderMessages();

    startWaitingMessages();

    let fullResponse = '';

    try {
      const res = await fetch(`${CONFIG.apiUrl}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message,
          history: state.history.slice(0, -1)
            .filter(m => m.complete !== false)
            .slice(-10)
            .map(m => ({ role: m.role, content: m.content }))
        })
      });

      if (!res.ok || !res.body) throw new Error('Chat nicht erreichbar.');

      const reader  = res.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split('\n\n');
        buffer = parts.pop() || '';

        for (const part of parts) {
          const line = part.split('\n').find(l => l.startsWith('data: '));
          if (!line) continue;
          const payload = JSON.parse(line.slice(6));
          if (payload.token) {
            fullResponse += payload.token;
          }
        }
      }
      state.history[assistantIdx].complete = true;
      state.history[assistantIdx].content = fullResponse.trim();
      if (!state.open) {
        state.unreadCount++;
        updateBadge();
      }
    } catch (err) {
      state.history[assistantIdx].content = `Fehler: ${err.message}`;
      state.history[assistantIdx].complete = true;
    } finally {
      stopWaitingMessages();
      state.loading = false;
      typing.classList.remove('visible');
      persistHistory();
      renderMessages();
    }
  }

  function assistantAvatarSmHtml() {
    return `<div class="bab-avatar-sm"><img src="${BAB_LOGO_CDN}" alt="BAB" width="28" height="28" loading="lazy" decoding="async"></div>`;
  }

  // ── Render ───────────────────────────────────────────────────────
  function renderMessages() {
    list.innerHTML = state.history.map((m) => {
      const tsHtml = m.ts ? `<div class="bab-ts">${formatTime(m.ts)}</div>` : '';
      if (m.role === 'user') {
        return `<div class="bab-msg-row bab-msg-user">
          <div class="bab-bubble bab-user">${escapeHtml(m.content).replace(/\n/g, '<br>')}</div>
          ${tsHtml}
        </div>`;
      }
      if (!m.complete) {
        return `<div class="bab-msg-row bab-msg-assistant bab-msg-pending">
        ${assistantAvatarSmHtml()}
        <div class="bab-bubble-wrap">
          <div class="bab-bubble bab-assistant bab-typing-wait" aria-busy="true">
            <span class="bab-typing-inline">Assistent schreibt…</span>
            <span class="bab-typing-inline-dots" aria-hidden="true"><span></span><span></span><span></span></span>
          </div>
        </div>
      </div>`;
      }
      const html = formatAssistant(m.content);
      return `<div class="bab-msg-row bab-msg-assistant">
        ${assistantAvatarSmHtml()}
        <div class="bab-bubble-wrap">
          <div class="bab-bubble bab-assistant">${html}</div>
          ${tsHtml}
        </div>
      </div>`;
    }).join('');
    list.scrollTop = list.scrollHeight;
  }

  function formatTime(iso) {
    try {
      return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    } catch { return ''; }
  }

  function now() { return new Date().toISOString(); }

  function parseMarkdownLinks(text) {
    const stripTrail = /[\]\[).,;!?"']+$/g;
    // [Label](URL)
    text = text.replace(/\[([^\[\]]+)\]\((https?:\/\/[^\s)"']+)\)/gi, (_m, label, url) => {
      const u = String(url).replace(stripTrail, '');
      return `<a href="${escapeAttr(u)}" target="_blank" rel="noopener noreferrer" class="bab-chat-link">${label}</a>`;
    });
    // bare URLs not already in href
    text = text.replace(/(?<!href=")(https?:\/\/[^\s<>"'\]]+)/gi, (full) => {
      const u = String(full).replace(stripTrail, '');
      return `<a href="${escapeAttr(u)}" target="_blank" rel="noopener noreferrer" class="bab-chat-link">${escapeHtml(u)}</a>`;
    });
    return text;
  }

  function formatAssistant(raw) {
    let s = escapeHtml(raw || '');
    s = parseMarkdownLinks(s);
    s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    s = s.replace(/\n/g, '<br>');
    return s;
  }

  // ── Storage ──────────────────────────────────────────────────────
  function loadHistory() {
    try {
      const raw = sessionStorage.getItem(CONFIG.sessionKey);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.slice(-CONFIG.maxMessages).map(m => ({
        role: m?.role === 'assistant' ? 'assistant' : 'user',
        content: String(m?.content || ''),
        complete: true,
        ts: m?.ts || null
      }));
    } catch { return []; }
  }

  function persistHistory() {
    sessionStorage.setItem(CONFIG.sessionKey, JSON.stringify(
      state.history.filter(m => m.complete).slice(-CONFIG.maxMessages)
        .map(m => ({ role: m.role, content: m.content, ts: m.ts }))
    ));
  }

  function escapeHtml(v) {
    return String(v)
      .replaceAll('&', '&amp;').replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
  }

  function escapeAttr(v) { return escapeHtml(v).replaceAll('"', '&quot;'); }

  // ── Markup ───────────────────────────────────────────────────────
  function buildMarkup() {
    const c = CONFIG.colors;
    const first = suggestions.slice(0, 4);
    const rest  = suggestions.slice(4);
    const chipBtn = (ch) =>
      `<button type="button" class="bab-chip" data-chip="${escapeAttr(ch.text)}">${escapeHtml(`${ch.icon} ${ch.text}`)}</button>`;
    const chipHtmlFirst = first.map(chipBtn).join('');
    const chipHtmlRest  = rest.length
      ? `<div class="bab-chips-extra">${rest.map(chipBtn).join('')}</div><button type="button" class="bab-chips-toggle">Mehr anzeigen</button>`
      : '';

    return `
<style>
/* ─── Base ─────────────────────────────────────────────────────────────── */
#bab-ai-widget-root{font-family:'DM Sans',system-ui,sans-serif;z-index:2147483000}
#bab-ai-widget-root *{box-sizing:border-box}

/* ─── FAB ──────────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-fab-wrap{position:fixed;right:20px;bottom:20px;z-index:2147483001}
#bab-ai-widget-root .bab-fab{
  width:56px;height:56px;border-radius:50%;border:none;cursor:pointer;
  background:${c.red};color:#fff;display:flex;align-items:center;justify-content:center;
  box-shadow:0 6px 20px rgba(0,0,0,.35);position:relative;
  animation:bab-pulse 2.4s ease-in-out infinite}
@keyframes bab-pulse{
  0%,100%{box-shadow:0 0 0 0 rgba(158,53,72,.45),0 6px 20px rgba(0,0,0,.35)}
  50%{box-shadow:0 0 0 12px rgba(158,53,72,0),0 6px 20px rgba(0,0,0,.35)}}
#bab-ai-widget-root .bab-badge{
  position:absolute;top:-4px;right:-4px;background:#e53;color:#fff;
  border-radius:50%;min-width:20px;height:20px;font-size:11px;font-weight:700;
  display:none;align-items:center;justify-content:center;border:2px solid #fff;padding:0 2px}
#bab-ai-widget-root .bab-fab-tooltip{
  position:absolute;right:68px;bottom:10px;white-space:nowrap;
  background:#2d333b;color:#fff;padding:8px 12px;border-radius:8px;font-size:13px;
  opacity:0;pointer-events:none;transition:opacity .15s}
#bab-ai-widget-root .bab-fab-tooltip.visible{opacity:1}

/* ─── Panel ─────────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-panel{
  position:fixed;right:20px;bottom:92px;
  width:420px;height:580px;
  max-height:calc(100vh - 120px);
  min-width:320px;max-width:700px;min-height:400px;
  background:${c.panel};color:${c.text};
  border-radius:16px;border:1px solid #333a44;
  box-shadow:0 12px 48px rgba(0,0,0,.6);
  display:none;flex-direction:column;overflow:hidden}
#bab-ai-widget-root .bab-panel.open{
  display:flex;animation:bab-slide-up .25s ease-out}
@keyframes bab-slide-up{
  from{opacity:0;transform:translateY(12px)}
  to{opacity:1;transform:translateY(0)}}

/* Resize handle – top-left corner */
#bab-ai-widget-root .bab-resize-handle{
  position:absolute;top:0;left:0;width:18px;height:18px;
  cursor:nwse-resize;z-index:10;border-radius:16px 0 0 0}
#bab-ai-widget-root .bab-resize-handle::after{
  content:'';position:absolute;top:4px;left:4px;
  width:6px;height:6px;border-top:2px solid #4a5568;border-left:2px solid #4a5568;border-radius:1px}

/* ─── Header ────────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-head{
  flex-shrink:0;display:flex;align-items:center;justify-content:space-between;
  padding:0 14px;height:56px;background:#1a1a1a;border-bottom:1px solid #2a2a2a;
  position:relative}
#bab-ai-widget-root .bab-head::before{
  content:'';position:absolute;top:0;left:0;right:0;height:3px;
  background:${c.teal};border-radius:16px 16px 0 0}
#bab-ai-widget-root .bab-head-left{display:flex;align-items:center;gap:10px}
#bab-ai-widget-root .bab-logo{
  width:36px;height:36px;flex-shrink:0;display:flex;align-items:center;
  justify-content:center;border-radius:8px;overflow:hidden;background:transparent}
#bab-ai-widget-root .bab-logo img{
  width:36px;height:36px;object-fit:contain;border-radius:8px;display:block}
#bab-ai-widget-root .bab-head-info{display:flex;flex-direction:column;gap:1px}
#bab-ai-widget-root .bab-head-title{font-weight:700;font-size:14px;line-height:1.2}
#bab-ai-widget-root .bab-head-sub{font-size:11px;color:${c.muted};display:flex;align-items:center;gap:5px}
#bab-ai-widget-root .bab-dot{width:7px;height:7px;border-radius:50%;background:#3dcc85;flex-shrink:0}
#bab-ai-widget-root .bab-head-btns{display:flex;gap:2px}
#bab-ai-widget-root .bab-head-btn{
  border:none;background:transparent;color:#888;font-size:20px;line-height:1;
  cursor:pointer;padding:6px 8px;border-radius:6px;transition:background .15s,color .15s}
#bab-ai-widget-root .bab-head-btn:hover{background:rgba(255,255,255,.08);color:#fff}

/* ─── Greeting ──────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-greeting{
  flex-shrink:0;display:none;align-items:flex-start;gap:10px;
  padding:12px 14px;font-size:14px;line-height:1.5;border-bottom:1px solid #2a2a2a}
#bab-ai-widget-root .bab-avatar{
  width:40px;height:40px;border-radius:50%;background:${c.teal};
  display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0}

/* ─── Chips ─────────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-chips{
  flex-shrink:0;display:none;flex-wrap:wrap;gap:8px;
  padding:10px 14px;border-bottom:1px solid #2a2a2a;align-items:center}
#bab-ai-widget-root .bab-chips-extra{display:none;flex-wrap:wrap;gap:8px;width:100%}
#bab-ai-widget-root .bab-chips-extra.open{display:flex}
#bab-ai-widget-root .bab-chips-toggle{
  width:100%;margin-top:4px;border:1px dashed #3d4654;background:transparent;
  color:${c.muted};border-radius:8px;padding:6px 10px;font-size:12px;cursor:pointer;
  transition:border-color .15s,color .15s}
#bab-ai-widget-root .bab-chips-toggle:hover{border-color:${c.teal};color:${c.text}}
#bab-ai-widget-root .bab-chip{
  border:1px solid #3d4654;background:#242424;color:#fff;border-radius:999px;
  padding:6px 12px;font-size:12px;cursor:pointer;text-align:left;
  line-height:1.3;transition:border-color .15s,background .15s}
#bab-ai-widget-root .bab-chip:hover{border-color:${c.teal};background:#2e2e2e}

/* ─── Messages ──────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-messages,#bab-ai-widget-root .bab-chat-messages{
  flex:1;overflow-y:auto;padding:16px;
  display:flex;flex-direction:column;gap:14px}
/* Nachrichten Scrollbar (im <style>-Block von buildMarkup) */
#bab-ai-widget-root .bab-messages::-webkit-scrollbar,
#bab-ai-widget-root .bab-chat-messages::-webkit-scrollbar{width:3px!important}
#bab-ai-widget-root .bab-messages::-webkit-scrollbar-track,
#bab-ai-widget-root .bab-chat-messages::-webkit-scrollbar-track{
  background:transparent!important}
#bab-ai-widget-root .bab-messages::-webkit-scrollbar-thumb,
#bab-ai-widget-root .bab-chat-messages::-webkit-scrollbar-thumb{
  background:rgba(111,156,163,.4)!important;border-radius:3px!important}

/* Message rows */
#bab-ai-widget-root .bab-msg-row{display:flex;flex-direction:column}
#bab-ai-widget-root .bab-msg-user{align-self:flex-end;align-items:flex-end;max-width:80%}
#bab-ai-widget-root .bab-msg-assistant{
  align-self:flex-start;flex-direction:row;align-items:flex-start;
  gap:8px;max-width:90%}
#bab-ai-widget-root .bab-bubble-wrap{display:flex;flex-direction:column;gap:3px;min-width:0}
#bab-ai-widget-root .bab-avatar-sm{
  width:28px;height:28px;border-radius:50%;background:transparent;
  display:flex;align-items:center;justify-content:center;
  flex-shrink:0;margin-top:2px;overflow:hidden}
#bab-ai-widget-root .bab-avatar-sm img{
  width:28px;height:28px;object-fit:contain;border-radius:50%;
  background:#1a1a1a;padding:2px;display:block}
#bab-ai-widget-root .bab-typing-wait{
  display:flex;align-items:center;gap:8px;flex-wrap:wrap}
#bab-ai-widget-root .bab-typing-inline{font-size:14px;color:${c.muted}}
#bab-ai-widget-root .bab-typing-inline.bab-typingfade{
  animation:bab-typing-fade-in .45s ease-out both}
@keyframes bab-typing-fade-in{
  from{opacity:0}
  to{opacity:1}}
#bab-ai-widget-root .bab-typing-inline-dots{
  display:inline-flex;gap:4px;align-items:center;padding:2px 0}
#bab-ai-widget-root .bab-typing-inline-dots span{
  width:8px;height:8px;border-radius:50%;background:${c.teal};
  animation:bab-stream-dot 1.2s infinite}
#bab-ai-widget-root .bab-typing-inline-dots span:nth-child(2){animation-delay:.2s}
#bab-ai-widget-root .bab-typing-inline-dots span:nth-child(3){animation-delay:.4s}
@keyframes bab-stream-dot{
  0%,60%,100%{opacity:.3;transform:scale(1)}
  30%{opacity:1;transform:scale(1.2)}}

/* Bubbles */
#bab-ai-widget-root .bab-bubble{
  padding:10px 14px;font-size:14px;line-height:1.55;word-wrap:break-word;
  animation:bab-bubble-in .2s ease-out}
@keyframes bab-bubble-in{
  from{opacity:0;transform:translateY(6px)}
  to{opacity:1;transform:translateY(0)}}
#bab-ai-widget-root .bab-user{
  background:${c.red};color:#fff;
  border-radius:18px 18px 4px 18px}
#bab-ai-widget-root .bab-assistant{
  background:#242424;color:${c.text};
  border:1px solid rgba(255,255,255,.07);
  border-radius:18px 18px 18px 4px}
#bab-ai-widget-root .bab-ts{
  font-size:10px;color:${c.muted};padding:0 4px}
#bab-ai-widget-root .bab-msg-user .bab-ts{text-align:right}

/* Links */
#bab-ai-widget-root .bab-chat-link{
  color:${c.teal};text-decoration:underline;font-weight:600;word-break:break-all}
#bab-ai-widget-root .bab-chat-link:hover{color:#8fd4dc}

/* ─── Typing (Footer, optional / Reserve) ──────────────────────────────── */
#bab-ai-widget-root .bab-typing{
  flex-shrink:0;padding:0 16px 8px;font-size:12px;color:${c.muted};display:none}
#bab-ai-widget-root .bab-typing.visible{display:flex;gap:4px;padding:12px 16px;align-items:center}
#bab-ai-widget-root .bab-typing-dots span{animation:bab-blink 1.2s infinite;opacity:.3}
#bab-ai-widget-root .bab-typing-dots span:nth-child(2){animation-delay:.2s}
#bab-ai-widget-root .bab-typing-dots span:nth-child(3){animation-delay:.4s}
@keyframes bab-blink{0%,80%,100%{opacity:.2}40%{opacity:1}}

/* ─── Consent Banner ─────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-consent-banner{
  flex-shrink:0;display:none;flex-direction:column;gap:10px;
  background:#1b2629;border-top:1px solid ${c.teal}44;
  padding:12px 14px;font-size:12px;color:${c.text};line-height:1.5}
#bab-ai-widget-root .bab-consent-actions{display:flex;gap:8px}
#bab-ai-widget-root .bab-consent-full{
  flex:1;padding:8px 12px;border-radius:8px;border:none;cursor:pointer;
  background:${c.teal};color:#fff;font-weight:600;font-size:12px;
  transition:opacity .15s}
#bab-ai-widget-root .bab-consent-full:hover{opacity:.85}
#bab-ai-widget-root .bab-consent-minimal{
  flex:1;padding:8px 12px;border-radius:8px;cursor:pointer;
  background:transparent;border:1px solid #3d4654;color:${c.muted};
  font-size:12px;transition:border-color .15s,color .15s}
#bab-ai-widget-root .bab-consent-minimal:hover{border-color:${c.teal};color:${c.text}}

/* ─── Input ──────────────────────────────────────────────────────────────── */
#bab-ai-widget-root .bab-input-wrap{
  flex-shrink:0;padding:10px 12px 12px;border-top:1px solid #2a2a2a}
#bab-ai-widget-root .bab-form{display:flex;gap:8px;align-items:flex-end}
#bab-ai-widget-root .bab-textarea-wrap{flex:1;position:relative}
#bab-ai-widget-root .bab-input{
  width:100%;background:#242424;border:1px solid #3d4654;border-radius:12px;
  padding:10px 12px;color:#fff;font-size:14px;font-family:inherit;
  resize:none;overflow-y:auto;min-height:42px;max-height:120px;
  line-height:1.4;display:block;transition:border-color .15s}
#bab-ai-widget-root .bab-input:focus{outline:none;border-color:${c.teal}}
#bab-ai-widget-root .bab-input::placeholder{color:${c.muted}}
/* Textarea Scrollbar */
#bab-ai-widget-root .bab-input::-webkit-scrollbar,
#bab-ai-widget-root textarea.bab-input::-webkit-scrollbar{width:3px!important}
#bab-ai-widget-root .bab-input::-webkit-scrollbar-track,
#bab-ai-widget-root textarea.bab-input::-webkit-scrollbar-track{
  background:transparent!important}
#bab-ai-widget-root .bab-input::-webkit-scrollbar-thumb,
#bab-ai-widget-root textarea.bab-input::-webkit-scrollbar-thumb{
  background:rgba(111,156,163,.4)!important;border-radius:3px!important}
/* Firefox */
#bab-ai-widget-root .bab-messages,
#bab-ai-widget-root .bab-chat-messages,
#bab-ai-widget-root .bab-input{
  scrollbar-width:thin!important;
  scrollbar-color:rgba(111,156,163,.4) transparent!important}
#bab-ai-widget-root .bab-charcount{
  font-size:10px;color:${c.muted};text-align:right;padding-top:3px}
#bab-ai-widget-root .bab-send{
  background:${c.red};color:#fff;border:none;border-radius:50%;
  width:42px;height:42px;cursor:pointer;display:flex;align-items:center;
  justify-content:center;flex-shrink:0;transition:opacity .15s,transform .1s}
#bab-ai-widget-root .bab-send:hover{opacity:.85}
#bab-ai-widget-root .bab-send:active{transform:scale(.92)}
</style>

<div class="bab-fab-wrap">
  <div class="bab-fab-tooltip">Ich helfe Ihnen gerne! 💬</div>
  <button type="button" class="bab-fab" aria-label="BAB Berater öffnen">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
      <path d="M8 9h8M8 13h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <span class="bab-badge" aria-hidden="true">1</span>
  </button>
</div>

<section class="bab-panel" aria-label="BAB Helfer">
  <div class="bab-resize-handle" title="Größe ändern" aria-hidden="true"></div>

  <div class="bab-head">
    <div class="bab-head-left">
      <div class="bab-logo">
        <img src="${BAB_LOGO_CDN}" alt="BAB" width="36" height="36" loading="lazy" decoding="async">
      </div>
      <div class="bab-head-info">
        <div class="bab-head-title">Helfer</div>
        <div class="bab-head-sub">
          <span class="bab-dot" aria-hidden="true"></span>Online
        </div>
      </div>
    </div>
    <div class="bab-head-btns">
      <button type="button" class="bab-head-btn bab-minimize" aria-label="Minimieren" title="Minimieren">&#8722;</button>
      <button type="button" class="bab-head-btn bab-close" aria-label="Schließen" title="Schließen">&#215;</button>
    </div>
  </div>

  <div class="bab-greeting">
    <div class="bab-avatar" aria-hidden="true">👋</div>
    <div>Hallo! 👋 Ich bin Ihr persönlicher BAB Berater. Womit kann ich helfen?</div>
  </div>

  <div class="bab-chips">${chipHtmlFirst}${chipHtmlRest}</div>

  <div class="bab-messages bab-chat-messages" role="log" aria-live="polite" aria-label="Chatverlauf"></div>

  <div class="bab-typing" aria-live="polite">
    <span class="bab-typing-dots">Assistent schreibt&nbsp;<span>.</span><span>.</span><span>.</span></span>
  </div>

  <div class="bab-consent-banner" role="region" aria-label="Datenschutzhinweis">
    <div>🔒 Ihre Anfragen werden anonym ausgewertet, um den Service zu verbessern.
      <a href="/policies/privacy-policy" style="color:${c.teal};text-decoration:underline">Datenschutz</a>
    </div>
    <div class="bab-consent-actions">
      <button type="button" class="bab-consent-full">Einverstanden</button>
      <button type="button" class="bab-consent-minimal">Nur nötige Daten</button>
    </div>
  </div>

  <div class="bab-input-wrap">
    <form class="bab-form">
      <div class="bab-textarea-wrap">
        <textarea class="bab-input" maxlength="${CONFIG.maxChars}" rows="1"
          placeholder="Frage stellen…" autocomplete="off"
          aria-label="Ihre Nachricht"></textarea>
        <div class="bab-charcount">0/${CONFIG.maxChars}</div>
      </div>
      <button type="submit" class="bab-send" aria-label="Senden">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 19V5m0 0l-6 6m6-6l6 6"
            stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </form>
  </div>
</section>`;
  }
})();
